import { render, staticRenderFns } from "./UpsellAnalytics.vue?vue&type=template&id=2edb0064&scoped=true"
import script from "./UpsellAnalytics.vue?vue&type=script&lang=js"
export * from "./UpsellAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edb0064",
  null
  
)

export default component.exports